import { render, staticRenderFns } from "./DynamicSection.vue?vue&type=template&id=1125fda0"
import script from "./DynamicSection.vue?vue&type=script&lang=js"
export * from "./DynamicSection.vue?vue&type=script&lang=js"
import style0 from "./DynamicSection.vue?vue&type=style&index=0&id=1125fda0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports